(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  document.getElementById('cs-footer-form').addEventListener('submit', async function (e) {
    e.preventDefault();

    // Honeypot check — silently reject if filled in
    if (document.getElementById('cs-footer-honeypot').value !== '') {
      return;
    }

    const email = document.getElementById('cs-email').value;
    const responseElement = document.getElementById('cs-form-response');
    const submitButton = document.getElementById('cs-submit');
    const originalButtonText = submitButton.value;

    submitButton.value = 'Please wait...';
    submitButton.disabled = true;

    try {
      const response = await fetch('https://a.klaviyo.com/client/subscriptions?company_id=XmQPZA', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/vnd.api+json',
          'revision': '2026-07-15',
        },
        body: JSON.stringify({
          data: {
            type: 'subscription',
            attributes: {
              profile: {
                data: {
                  type: 'profile',
                  attributes: {
                    email,
                    subscriptions: {
                      email: {
                        marketing: {
                          consent: 'SUBSCRIBED',
                        },
                      },
                    },
                  },
                },
              },
            },
            relationships: {
              list: {
                data: {
                  type: 'list',
                  id: 'Rqap4p',
                },
              },
            },
          },
        }),
      });

      if (response.ok) {
        responseElement.textContent = 'Thank you for subscribing!';
        document.getElementById('cs-email').value = '';
      } else {
        responseElement.textContent = 'Oops, something went wrong.';
        responseElement.style.color = '#920C0E';
      }
    } catch (error) {
      console.error('Error:', error);
      responseElement.textContent = 'There was a problem submitting the form.';
      responseElement.style.color = '#920C0E';
    } finally {
      submitButton.value = originalButtonText;
      submitButton.disabled = false;
    }
  });

  } catch(e) { console.error(e); }
})();
})();
